import {
  ISharedFileRequestSettingsCreateRequest,
  ISharedFileRequestSettingsResponse
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import * as Yup from "yup";

import { CreateRequirementDefinitionSharedFileMimeType } from "../../../../../Requirements/modules/SharedFile/types";
import { mapMimeTypesToRequestFormat } from "../../../../modules/BackgroundChecks/createRequirementDefinition/mapMimeTypesToRequestFormat";
import { RequirementDefinitionSmartSharedFileFormValues } from "../../../../types";
import { RequirementDefinitionTemplateForm } from "../../types";

import { STANDARD_SHARED_FILE_FORM } from "./StandardSharedFile";

export const getSmartSharedFileForm = (
  mimeTypes: Partial<
    Record<CreateRequirementDefinitionSharedFileMimeType, boolean>
  >
): RequirementDefinitionTemplateForm<
  ISharedFileRequestSettingsResponse,
  RequirementDefinitionSmartSharedFileFormValues,
  ISharedFileRequestSettingsCreateRequest
> => {
  return {
    ...STANDARD_SHARED_FILE_FORM,
    mapFormDataToDataSourceCreateRequest(values, template) {
      return {
        contextType: Array.isArray(template.contextType)
          ? template.contextType[0]
          : template.contextType,
        instructions: template.instructions!,
        mimeTypes: mapMimeTypesToRequestFormat(mimeTypes),
        title: template.name
      };
    },
    mapFormDataToRequirementCreateRequest: undefined,
    partialForm: null,
    successCreationMessage: "Requirement created successfully",
    validationSchema: Yup.object().shape({
      instructions: Yup.string()
    })
  };
};
